(() => {
  if (window.vyroCapGalleryLoaded) return;
  window.vyroCapGalleryLoaded = true;

  const colorOf = (slide) => slide.querySelector('img')?.alt.trim().split(/\s+/)[0].toLowerCase();

  const arrange = (productInfo, selectedColor) => {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    const colors = productInfo.dataset.vyroColorOrder?.split(',').filter(Boolean) || [];
    const selected = selectedColor?.toLowerCase();
    if (!colors.includes(selected)) return;
    const order = [selected, ...colors.filter((color) => color !== selected)];

    const lists = [gallery.elements.viewer?.querySelector('ul'), gallery.elements.thumbnails?.querySelector('ul')];
    lists.forEach((list) => {
      if (!list) return;
      const slides = Array.from(list.children).filter((slide) => slide.matches('li'));
      order.forEach((color) => {
        slides.filter((slide) => colorOf(slide) === color).forEach((slide) => list.append(slide));
      });
      slides.filter((slide) => !colors.includes(colorOf(slide))).forEach((slide) => list.append(slide));

      if (list === gallery.elements.thumbnails?.querySelector('ul')) {
        Array.from(list.children).forEach((slide, index) => {
          slide.dataset.mediaPosition = String(index + 1);
          const button = slide.querySelector('button[aria-label]');
          if (button) button.setAttribute('aria-label', button.getAttribute('aria-label').replace(/\d+/, String(index + 1)));
        });
      }
    });

    gallery.elements.viewer?.resetPages?.();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('product-info.vyro-cap-product').forEach((productInfo) => {
      const activeAlt = productInfo.querySelector('media-gallery .product__media-item.is-active img')?.alt;
      arrange(productInfo, activeAlt?.trim().split(/\s+/)[0]);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info.vyro-cap-product[data-section="${data.sectionId}"]`);
      if (productInfo) arrange(productInfo, data.variant?.option1 || data.variant?.options?.[0]);
    });
  }
})();
